export default __webpack_public_path__ + "content/media/23.e64644e5.jpg";